import { useState } from 'react'
import { BaseButtons, BaseIconButtons, BaseTextInput } from 'inputs'
import { BaseGridLayout } from 'layout'
import { useApiRequest } from './ApiRequestProvider'

export default function ModificaUrlServer() {
  const {
    urlServer,
    setUrlServer,
    resetDefaultUrlServer,
    isDefaultUrlServer,
    isUrlServerSaved,
    URL_SERVER_ENRICO,
    URL_SERVER_LUCA
  } = useApiRequest()

  const [url, setUrl] = useState(urlServer)

  const isUrlSaved = isUrlServerSaved(url)
  const isUrlDefault = isDefaultUrlServer(url)

  return (
    <BaseGridLayout alignCenter>
      <BaseTextInput
        label='URL backend'
        value={url}
        onChange={e => setUrl(e.target.value)}
        larghezza={35}
        endAdornment={
          <>
            <BaseIconButtons.Salva
              onClick={() => setUrlServer(url)}
              disabled={isUrlSaved}
              contenutoTooltip={isUrlSaved
                ? 'URL già salvato'
                : 'Salva'
              }
              color='primary'
            />
            <BaseIconButtons.AnnullaModifiche
              onClick={() => {
                const defaultUrl = resetDefaultUrlServer()
                setUrl(defaultUrl)
              }}
              disabled={isUrlDefault}
              contenutoTooltip={isUrlDefault
                ? 'URL corrente è quello predefinito'
                : 'Ripristina URL predefinito'
              }
              color='secondary'
            />
          </>
        }
      />

      {URL_SERVER_ENRICO &&
        <BaseButtons.Custom
          testo='URL Enrico'
          onClick={() => setUrl(URL_SERVER_ENRICO)}
          color='success'
        />
      }

      {URL_SERVER_LUCA &&
        <BaseButtons.Custom
          testo='URL Luca'
          onClick={() => setUrl(URL_SERVER_LUCA)}
          color='success'
        />
      }
    </BaseGridLayout>
  )
}
